import React, {useState} from "react";


function BooleanField({fieldObj, fieldIndex, fieldUpdatedFunction, singleLocationMode, readOnly}){

    const [myValue, setMyValue] = useState(singleLocationMode || readOnly ? fieldObj.value : undefined)

    const isDisabled = () => {
        if(readOnly){
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }

    const handleOptionChange = (on) => (event) => {
        fieldObj.value = on
        setMyValue(on)
        fieldUpdatedFunction(fieldObj)
    };

    return <div>
        <table style={{"width": "100%"}}>
            <tbody style={{"width": "100%"}}>
            <tr>
                <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}{fieldObj.fieldDisplayName}</td>
                <td style={{"width": "200px"}}>
                    <div className="custom-control custom-checkbox control-spacer-left inline-block">
                        <input type="checkbox" id={fieldObj.fieldId + "-yes" + fieldIndex} className="custom-control-input" checked={myValue == true}  disabled={isDisabled()} onChange={handleOptionChange(true)} />
                        <label className="custom-control-label" htmlFor={fieldObj.fieldId + "-yes" + fieldIndex}>Yes &nbsp;</label>
                    </div>
                    <div className="custom-control custom-checkbox control-spacer-left inline-block">
                        <input type="checkbox" id={fieldObj.fieldId + "-no" + fieldIndex} className="custom-control-input" checked={myValue == false}  disabled={isDisabled()} onChange={handleOptionChange(false)} />
                        <label className="custom-control-label" htmlFor={fieldObj.fieldId + "-no" + fieldIndex}>No&nbsp;{" "}</label>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

    </div>


}

export default BooleanField;